
function NotFound() {
    return <h2>Страница не найдена</h2>;
}

export default NotFound